import React from 'react';
import { Checkbox } from 'react-bootstrap';
import CategorySelect from './CategorySelect.jsx';
import RevertIcon from '../icons/RevertIcon.jsx';

const CategoriesHeader = (props) => {
  const { filtersData, onSelectAll, allSelected, resetAllAction } = props;

  return (
    <div className="flex flex-justify flex-align-start">
      <div className="flex flex-align-start">
        <h3 className="m-t-8">Categories:</h3>

        <div className="flex flex-wrap">
          {filtersData.map((category) => (
            <React.Fragment key={category.key}>
              <CategorySelect category={category} {...props} />
            </React.Fragment>
          ))}
        </div>
        <div className="m-l-18" style={{ minWidth: '110px' }}>
          <Checkbox
            className="label-left"
            style={{ margin: '8px 0' }}
            checked={allSelected}
            onChange={() => onSelectAll()}
          >
            <span style={{ fontSize: '16px' }}>Select All</span>
            <span className="checkmark"></span>
          </Checkbox>
        </div>
      </div>

      <button
        className="btn-clear bordered flex flex-align-center m-l-12"
        style={{ minWidth: '142px' }}
        onClick={() => resetAllAction()}
      >
        <RevertIcon />
        <strong style={{ padding: '0 10px' }}>Reset filters</strong>
      </button>
    </div>
  );
};

export default CategoriesHeader;
